export const playListMove = (section) => {
	const playListHeader = section.querySelector( '.playlist header' );
	
	var xDown = null;
	var yDown = null;                                                        
	
	function handleTouchStart(evt) {                                      
		xDown = evt.touches[0].clientX;                                      
		yDown = evt.touches[0].clientY; 
		document.querySelector('html').style = 'overflow: hidden';                                     
	}; 
	
	const touchHandle = (evt) => {
	if ( ! xDown || ! yDown ) {
			return;
		}
	
		var xUp = evt.touches[0].clientX;                                    
		var yUp = evt.touches[0].clientY;
	
		var xDiff = xDown - xUp;
		var yDiff = yDown - yUp;
	
		if ( Math.abs( xDiff ) < Math.abs( yDiff ) ) {/*most significant*/
			if ( yDiff < 0 ) { 
				playListHeader.parentNode.classList.remove('active');
				setTimeout(() => {
					document.querySelector('html').style = 'overflow: visible';  
				}, 400)
			}
			if ( yDiff > 0 ) { 
				playListHeader.parentNode.classList.add('active');
			}                                                                  
		}
		xDown = null;
		yDown = null; 
	}
	
	playListHeader.addEventListener('touchstart', handleTouchStart );
	playListHeader.addEventListener('touchmove', touchHandle );
}
